import React from 'react';
import { clsx } from 'clsx';

const glowAccents = {
  none: '',
  red: 'glass-card--red',
  blue: 'glass-card--blue',
  green: 'glass-card--green',
  gold: 'glass-card--gold',
  navy: 'glass-card--navy',
};

export const GlassCard = ({
  children,
  className,
  title,
  action,
  accent = 'none',
  hover = true,
}) => {
  return (
    <div
      className={clsx(
        'glass-card',
        hover && 'glass-card--hover',
        glowAccents[accent],
        className
      )}
    >
      {(title || action) && (
        <div className="glass-card__header">
          {title && <h3 className="glass-card__title">{title}</h3>}
          {action && <div>{action}</div>}
        </div>
      )}
      <div className="glass-card__body">
        {children}
      </div>
    </div>
  );
};

export default GlassCard;
